/* Arvin Olesco — theme scripts */
(function () {
  'use strict';

  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  /* ---------- Cart drawer ---------- */

  function drawer() {
    return document.getElementById('CartDrawer');
  }

  function openDrawer() {
    const el = drawer();
    if (!el) {
      window.location.href = window.routes.cart_url;
      return;
    }
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    const close = el.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    const el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      const html = sections[id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const fresh = doc.querySelector('[data-drawer-inner]');
        const current = document.querySelector('#CartDrawer [data-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
      }
      if (id === 'cart-icon-bubble') {
        const fresh = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          if (fresh) {
            node.textContent = fresh.textContent;
            node.dataset.count = fresh.dataset.count;
          }
        });
      }
    });
  }

  function addToCart(form, button) {
    const formData = new FormData(form);
    formData.append('sections', CART_SECTIONS.join(','));
    formData.append('sections_url', window.location.pathname);

    if (button) button.classList.add('is-loading');
    clearError(form);

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          showError(form, data.description || data.message);
          return;
        }
        renderSections(data.sections);
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    const inner = document.querySelector('#CartDrawer [data-drawer-inner]');
    if (inner) inner.style.opacity = '.5';
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: CART_SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (window.location.pathname === window.routes.cart_url) {
          window.location.reload();
          return;
        }
        renderSections(data.sections);
      })
      .finally(function () {
        const fresh = document.querySelector('#CartDrawer [data-drawer-inner]');
        if (fresh) fresh.style.opacity = '';
      });
  }

  function showError(form, message) {
    let box = form.querySelector('[data-form-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function clearError(form) {
    const box = form.querySelector('[data-form-error]');
    if (box) box.hidden = true;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (!document.getElementById('CartDrawer')) return;
    event.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener && drawer()) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const remove = event.target.closest('[data-line-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(Number(remove.dataset.lineRemove), 0);
      return;
    }

    const step = event.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('.qty');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      const min = Number(input.min) || 0;
      const next = Math.max(min, (Number(input.value) || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      if (input.dataset.line) changeLine(Number(input.dataset.line), next);
      return;
    }

    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById('MobileNav');
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (input.matches('.qty input[data-line]')) {
      changeLine(Number(input.dataset.line), Math.max(0, Number(input.value) || 0));
    }
    if (input.matches('[data-sort-select]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', input.value);
      window.location.href = url.toString();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  /* ---------- Product: variants + media ---------- */

  function initProduct(root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = root.querySelector('[data-product-form]');
    const idInput = form && form.querySelector('input[name="id"]');
    const submit = form && form.querySelector('[type="submit"]');
    const submitLabel = submit && submit.querySelector('[data-label]');
    const priceEl = root.querySelector('[data-price]');
    const picker = root.querySelector('[data-variant-picker]');
    const strings = root.dataset;

    function selectedOptions() {
      return Array.from(picker.querySelectorAll('fieldset')).map(function (fs) {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function updateAvailability(options) {
      picker.querySelectorAll('fieldset').forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          const test = options.slice();
          test[index] = input.value;
          const match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
        const legendValue = fs.querySelector('[data-selected-value]');
        if (legendValue) legendValue.textContent = options[index];
      });
    }

    function onChange() {
      const options = selectedOptions();
      const variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
      updateAvailability(options);

      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (priceEl) {
        const url = root.dataset.url + '?variant=' + variant.id + '&section_id=' + root.dataset.sectionId;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-price]');
            if (fresh) priceEl.innerHTML = fresh.innerHTML;
          });
      }

      if (variant.featured_media) showMedia(root, variant.featured_media.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      updateAvailability(selectedOptions());
    }

    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(root, thumb.dataset.thumb); });
    });
  }

  function showMedia(root, mediaId) {
    const target = root.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target) return;
    root.querySelectorAll('[data-media-id]').forEach(function (slide) {
      const active = slide === target;
      slide.classList.toggle('is-active', active);
      if (!active) {
        slide.querySelectorAll('video').forEach(function (v) { v.pause(); });
      }
    });
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.dataset.thumb === String(mediaId)));
    });
  }

  /* ---------- Before / after slider ---------- */

  function initCompare(el) {
    const range = el.querySelector('.compare__range');
    if (!range) return;
    const update = function () { el.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', update);
    update();
  }

  /* ---------- Scroll reveal ---------- */

  function initReveal(scope) {
    const items = scope.querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Product recommendations ---------- */

  function initRecommendations(el) {
    if (!el.dataset.url || el.dataset.loaded) return;
    el.dataset.loaded = 'true';
    fetch(el.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      });
  }

  function init(scope) {
    scope.querySelectorAll('[data-product-root]').forEach(initProduct);
    scope.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('[data-compare]').forEach(initCompare);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('#CartDrawer')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('#CartDrawer')) closeDrawer();
  });
})();
